import { render, staticRenderFns } from "./SwipeContainer.vue?vue&type=template&id=46e19cab&scoped=true&"
import script from "./SwipeContainer.vue?vue&type=script&lang=js&"
export * from "./SwipeContainer.vue?vue&type=script&lang=js&"
import style0 from "./SwipeContainer.vue?vue&type=style&index=0&id=46e19cab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e19cab",
  null
  
)

export default component.exports